import * as React from "react"
import styles from "./DsProfileDropDownBackoffice.module.scss"

import { AppRoutes } from "@constants/AppRoutes.ts"
import { useNavigate } from "react-router-dom"
import { AppFunctions } from "@others/AppFunctions.ts"
import { useTranslation } from "react-i18next"

import useAuthCtx from "@contexts/hooks/useAuthCtx.tsx"
import DvAppDropdown from "@components/navigation/DvAppDropdown/DvAppDropdown.tsx"

interface IProps {
	className?: string
	children?: React.ReactNode
}

const DsProfileDropDownBackoffice: React.FC<IProps> = (props) => {
	const { t } = useTranslation()
	const { setIsLogged, setLoggedUser } = useAuthCtx()

	const navigate = useNavigate()

	const items = [
		{
			key: "logout",
			label: t("close_session"),
			onClick: () => {
				setIsLogged(false)
				AppFunctions.clearLoginDataFromLocalStorage()
				navigate(AppRoutes.login, { replace: true })
				setLoggedUser(undefined)
			},
		},
	]

	return (
		<DvAppDropdown
			className={`${styles.profile_drop_down} ${props.className || ""}`}
			overlayClassName={styles.overlay}
			menu={{ items }}
		>
			{props.children}
		</DvAppDropdown>
	)
}

export default React.memo(DsProfileDropDownBackoffice)
